module.exports = __webpack_public_path__ + "static/media/Spezia.c79f45cc.png";